import type { Feature } from './feature'
import { State } from './state'

export class Selectors {
  public readonly editor

  public readonly enhancementTypeStandardOptions
  public readonly enhancementTypeCurrentOptionsSelector

  public readonly enhancementTypeOptions
  public readonly isCreatingCustomEnhancementType

  public readonly isInUse

  public readonly enhancement
  public readonly enhancementIsLoading
  public readonly enhancementError

  constructor(feature: Feature) {
    this.editor = feature.state.project(state => state.editor?.())

    this.enhancementTypeStandardOptions = feature.state.project(
      state => state.enhancementTypeStandardOptions,
    )
    this.enhancementTypeCurrentOptionsSelector = feature.state.project(
      state => state.enhancementTypeCurrentOptionsSelector,
    )

    this.enhancementTypeOptions =
      this.enhancementTypeCurrentOptionsSelector.project(
        this.enhancementTypeStandardOptions.asSelector,
        (selector, standardOptions) => {
          if (!selector) {
            // This handles 0 and undefined
            return []
          }
          const options =
            // Starts with the relevant standard options
            selector === 'all'
              ? [...standardOptions]
              : selector === 'custom'
                ? []
                : // We subtract 1 to make space for the custom option
                  standardOptions.slice(0, selector - 1)
          options.push(State.ENHANCEMENT_TYPE_CUSTOM_OPTION)
          return options
        },
      )
    this.isCreatingCustomEnhancementType =
      this.enhancementTypeCurrentOptionsSelector.project(
        selector => selector === 'custom',
      )

    this.isInUse = this.enhancementTypeCurrentOptionsSelector.project(
      selector => selector !== undefined,
    )

    this.enhancement = feature.state.project(state => state.enhancement)
    this.enhancementIsLoading = feature.state.project(
      state => state.enhancementIsLoading,
    )
    this.enhancementError = feature.state.project(
      state => state.enhancementError,
    )
  }
}
